/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentactivity_Description1Inputs */

const he_dashboard_recentactivity_description1 = /** @type {(inputs: Dashboard_Recentactivity_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעולות אחרונות בפלטפורמה`)
};

const en_dashboard_recentactivity_description1 = /** @type {(inputs: Dashboard_Recentactivity_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest actions across the platform`)
};

/**
* | output |
* | --- |
* | "Latest actions across the platform" |
*
* @param {Dashboard_Recentactivity_Description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentactivity_description1 = /** @type {((inputs?: Dashboard_Recentactivity_Description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentactivity_Description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentactivity_description1(inputs)
	return en_dashboard_recentactivity_description1(inputs)
});
export { dashboard_recentactivity_description1 as "dashboard_recentActivity_description" }